import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import styles from './GroupUserTable.module.css'; // 원하는 스타일 적용
import { Today } from '@mui/icons-material';

const ProductTable = ({ groupId, users, onDeleteUsers, onAddUser, detailUser, onPrevPage, onNextPage, disablePrev, disableNext, pageNumber, totalCount, listSize, searchValue, setSearchValue, onSearch, isMobileWindow }) => {
  const [selected, setSelected] = useState([]);
  const [sortField, setSortField] = useState('userId');
  const [sortOrder, setSortOrder] = useState('asc');
  const [searchType, setSearchType] = useState("product");
  // const {openModal} = useContext(ModalContext);

  const [userInfo, setUserInfo] = useState({
    userId: sessionStorage.getItem("userId"),
    userName: sessionStorage.getItem("userName"),
    groupId: sessionStorage.getItem("groupId"),
    role: sessionStorage.getItem("role")
  })
  
  // 정렬 처리
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  const sortedUsers = [...users].sort((a, b) => {
    let valA = a[sortField];
    let valB = b[sortField];
    // 날짜 비교
    if (sortField === "createdDate" || sortField === "lastConnectionDate") {
      valA = Number(valA) || 0;
      valB = Number(valB) || 0;
    }
    if (valA < valB) return sortOrder === "asc" ? -1 : 1;
    if (valA > valB) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  // 체크박스 관련
  const isAllSelected = selected.length === users.length && users.length > 0;

  const handleSelectAll = () => {
    setSelected(isAllSelected ? [] : users.map(u => u.id));
  };

  const handleSelectRow = (id) => {
    setSelected(selected.includes(id)
      ? selected.filter(i => i !== id)
      : [...selected, id]);
  };

  // 삭제
  const handleDeleteSelected = () => {
    
    if (selected.length > 0) {
      onDeleteUsers(selected); // 리스트로 넘김
      setSelected([]);
    }
  };
  
  const handleSingleDelete = (id) => {
    onDeleteUsers([id]);
    setSelected(selected.filter(i => i !== id));
  };

  const transStatusView = (status) => {
    switch(status){
      case 'active':
        return '할당됨';
      case 'deactive':
        return '미할당';
      case 'expiration':
        return '만료';
      default:
        return status;
    }
  };

  const handleStatusChange = (e) => {
      setSearchType(e.target.value);
  };

  return (
<div className={styles.tableSection}>
  <div className={styles.actionTopBar}>
    {/* 왼쪽: 검색 */}
    <div className={styles.actionBar}>
      <select name={"status"}
          className={styles.rightCont__cont__select} value={searchType}
          style={{appearance: "auto", padding: '10px 10px',  borderRadius: '4px', border: '1px solid #ccc'}}
          onChange={handleStatusChange}>
        <option value={"product"} defaultValue={true}>제품명</option>
      </select>
      <input
        className={styles.rightCont__cont__search} type="text" placeholder="제품 검색" value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        style={{
          padding: '10px 20px',
          borderRadius: '4px',
          border: '1px solid #ccc'
        }}
      />
      <button onClick={() => onSearch(searchType, searchValue)} className={styles.addBtn} >검  색</button>
    </div>
    {userInfo.role == 'SYS_ADMIN' && (
      <>
        {/* 오른쪽: 버튼 묶음 */}
        <div className={styles.actionBar}>
          <button onClick={handleDeleteSelected} className={styles.deleteBtn} disabled={selected.length === 0}>제  거</button>
          <button onClick={onAddUser} className={styles.addBtn}>추  가</button>
        </div>
      </>
    )}
  </div>
  {/* <div className={styles.actionBar}> */}
    {/* {groupId !== "0" && ( */}
      {/* <>
        <button onClick={handleDeleteSelected} className={styles.deleteBtn} disabled={selected.length === 0}>제거</button>
        <button onClick={onAddUser} className={styles.addBtn}> 유저 추가 </button>
      </> */}
    {/* )} */}
  {/* </div> */}
  <table className={styles.table}>
    <thead>
      <tr>
        <th className={styles.checkboxCell}>
          <input
            className={styles.userCheckbox}
            type="checkbox"
            checked={isAllSelected}
            onChange={handleSelectAll}
          />
        </th>
        <th className={styles.idCol} onClick={() => handleSort('product')} style={{cursor:'pointer'}}>
          제품명 {sortField === 'product' ? (sortOrder === 'asc' ? '▲' : '▼') : ''}
        </th>
        {/* <th className={styles.authCol}>권한</th>
        <th className={styles.removeCol}>그룹 제거</th> */}
      </tr>
    </thead>
    <tbody>
      {sortedUsers.map((user) => (
        // <tr key={user.id} className={styles.tableRow} onClick={() => handleRowClick(user.id)}  style={{ cursor: "pointer" }}>
        <tr key={user.id} className={styles.tableRow} onClick={() => detailUser(user.id)}  style={{ cursor: "pointer" }}>
          <td className={styles.checkboxCell}>
            <input
              className={styles.userCheckbox}
              type="checkbox"
              checked={selected.includes(user.id)}
              onClick={(e) => {e.stopPropagation()}}
              onChange={(e) => {
                handleSelectRow(user.id)
              }}
            />
          </td>
          <td className={styles.idCol}>{user.product}</td>
        </tr>
      ))}
      {users.length === 0 && (
        <tr>
          <td colSpan={2} style={{textAlign: "center", color: "#888"}}>제품이 없습니다.</td>
        </tr>
      )}
    </tbody>
  </table>
  <div className={styles.actionBar} style={{marginTop: "8px"}}>
    <>
      {totalCount > 0 && (
        <p className={styles.text} >{pageNumber * listSize + 1} - {Math.min((pageNumber * listSize + 1) + listSize - 1, totalCount)} of {totalCount} </p>
      )}
      <button className={styles.addBtn} onClick={onPrevPage} disabled={disablePrev}>{"<"}</button>
      <button className={styles.addBtn} onClick={onNextPage} disabled={disableNext}>{">"}</button>
    </>
  </div>
</div>
  );
};

export default ProductTable;
